import { RelevanceScaleIndicatorEnum } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';

export const generalScaleIndicatorOptions = [
  {
    value: RelevanceScaleIndicatorEnum.producedOnARelevantScale,
    label: 'S - Produzido em Escala Relevante',
  },
  {
    value: RelevanceScaleIndicatorEnum.producedAtNonRelevantScale,
    label: 'N - Produzido em Escala NÂO Relevante',
  },
];
